const KeenSlider = window.KeenSlider

const { setInitialised, usePagination } = window.BAO.Carousel.plugins
const { breakpoints } = window.BAO.MediaBreakpoints

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists || this.els.slide.elements.length <= 1) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.md}px)`]: {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        usePagination(this.els?.pagination?.element, {
          format: this.dataset.paginationFormat,
        }),
      ],
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
